<template>
<v-expansion-panels>
    <v-expansion-panel>
        <v-expansion-panel-header class="px-1">
            <v-row class="mx-0">
                <v-col md="8" cols="9">
                    <div class="regular font-weight-bold">
                        {{ room.count }} X {{ room.room_type.name }}
                        <span>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <template v-if="room.pax.adults < 3 ">
                                        <span v-for="(adult, index) in room.pax.adults" :key="'adult_'+index">
                                            <v-icon v-on="on" size="18">person</v-icon>
                                        </span>
                                    </template>
                                    <template v-else>
                                        <span>
                                            <v-icon v-on="on" size="18">person</v-icon>X{{ room.pax.adults }}
                                        </span>
                                    </template>
                                </template>
                                <div>
                                    <div v-if="room.pax.adults" class="px-1">{{ room.pax.adults }} {{ $tc('reservations.modal.adults', room.pax.adults) }}</div>
                                </div>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <template v-if="getChildren(room.pax) >0">
                                        <template v-if="getChildren(room.pax)< 3 ">
                                            <span v-on="on" v-for="child in getChildren(room.pax)">
                                                <v-icon size="18">person</v-icon>
                                            </span>
                                        </template>
                                        <template v-else>
                                            <span v-on="on" class="regular">
                                                <v-icon size="18">person</v-icon>X{{ getChildren(room.pax)}}
                                            </span>
                                        </template>
                                    </template>
                                </template>
                                <div>
                                    <div v-if="room.pax.infants" class="px-1">{{room.pax.infants}} infants</div>
                                    <div v-if="room.pax.small_children" class="px-1">{{room.pax.small_children}} small children</div>
                                    <div v-if="room.pax.big_children" class="px-1">{{room.pax.big_children}} big children</div>
                                </div>
                            </v-tooltip>
                        </span>
                    </div>
                    <div class="detail">{{ room.rate_plan.name }}</div>
                </v-col>
                <v-col md="4" cols="3" align-self="center">
                    <div v-if="$vuetify.breakpoint.smAndUp" class="d-flex justify-end align-center pr-2">
                        <span>{{ getDayAndMonth(room.check_in) }} </span>
                        <v-icon class="px-1">chevron_right</v-icon>
                        <span>{{ getDayAndMonth(room.check_out) }}</span>
                    </div>
                    <div v-else>
                        <im-period :check_in="room.check_in" :check_out="room.check_out" />
                    </div>
                </v-col>
            </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-card flat>
                <v-row no-gutters>
                    <v-col md="7" cols="6">
                        <div class="im-label">
                            {{ $t('reservations.modal.meal_type') }}
                        </div>
                        <div class="regular mt-1 mb-3 text-capitalize">
                            {{room.meal_type}}
                        </div>
                        <div class="im-label">
                            {{ $t('reservations.modal.occupancy') }}
                        </div>
                        <div class="regular mt-1 mb-3">
                            <span>{{room.pax.adults}} adulti</span>
                            <span v-if="room.pax.infants || room.pax.small_children || room.pax.big_children">, {{ getChildren(room.pax) }} adulti</span>
                        </div>
                    </v-col>
                    <v-col md="5" cols="6">
                        <div>
                            <div class="d-flex justify-space-between" v-for="(price_day, index2) in room.price" :key="index2">
                                <div class="detail pr-1">{{ getDayAndMonth(price_day.date) }}</div>
                                <div class="d-flex justify-end">
                                    <span class="font-weight-bold detail pr-1">{{ room.count }} x</span>
                                    <im-price v-if="isNew(room.price)" :price="price_day.amount" :currency="price_day.currency" fontSize="12" />
                                    <im-price v-else :price="room.total_price.amount" :currency="price_day.currency" fontSize="12" />
                                </div>
                            </div>
                            <v-divider></v-divider>
                        </div>
                        <div class="mt-2 d-flex justify-space-between">
                            <div class="regular">{{ $t('reservations.modal.total_price') }}</div>
                            <div class="important">
                                <im-price :price="room.count*room.total_price.amount" :currency="room.total_price.currency" class="pl-1" />
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-expansion-panel-content>
    </v-expansion-panel>
</v-expansion-panels>
</template>

<script>
import defaults from "../../../utils/PropDefaults.js";
import IMPrice from '../../../small-components/IMPrice.vue';
import IMPeriod from '../../../small-components/IMPeriod.vue';

export default {
    components: {
        'im-price': IMPrice,
        'im-period': IMPeriod,
    },

    props: {
        room: {
            type: Object,
            default: function () {
                return defaults.reservation_item.rooms[0]
            }
        },
    },

    data: () => {
        return {
            show_price: false,
        }
    },

    computed: {
        align_self() {
            return this.show_price ? 'flex-end' : 'flex-start'
        }
    },

    watch: {
        room: {
            handler: function () {
                this.show_price = false;
            },
        },
    },

    methods: {
        getDayAndMonth(date) {
            if(!date) return date;
            // let value = date * 1000;
            return this.$moment(date)
                .locale(this.$vuetify.lang.current)
                .format('DD.MMM');
        },

        getChildren(pax) {
            let children = pax.infants + pax.big_children + pax.small_children;
            return children
        },

        isNew(value) {
            if(value.length > 0) {
                if(value[0].amount === 0 || value[0].amount === "0" || value[0].amount == null) {
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        },
    },
}
</script>
